export default __webpack_public_path__ + "media/images/calendar-53d90e6eb32192ba9bd2ea8676915eb7.svg";